/* eslint-disable react/no-array-index-key */
import { Col } from 'react-bootstrap';
import { Select, SelectOption } from 'appkit-react';

const SourceGroupBy = ({
    srcGroupByList, shouldNotShowSrcGrpByList, updatedConfigData, sourceGroupBy,
    onSourceGroupBy,
}) => (
    <Col>
        <p className="true-comply-datarecon__reconcliationtype-sum__column">GROUP BY</p>
        <div className="true-comply-datarecon__reconcliationtype-sum__select">
            <Select
                placeholder="Select"
                multiple
                onSelect={onSourceGroupBy}
                value={sourceGroupBy}
            >
                {srcGroupByList && srcGroupByList.length > 0 && srcGroupByList.map((c, index) => (
                    <SelectOption key={`${c.column}_${index}`} value={c.column}>{c.displayName}</SelectOption>
                ))}
                {shouldNotShowSrcGrpByList && updatedConfigData[0].selectedColumns
                    .filter(
                        (arr, index, self) => index === self.findIndex(t => (t.column === arr.column)),
                    )
                    .map((c, index) => (
                        <SelectOption key={`${c.column}_${index}`} value={c.column}>{c.displayName}</SelectOption>
                    ))}
            </Select>
        </div>
    </Col>
);

export default SourceGroupBy;
